import { Stack, type Theme, Typography, useMediaQuery } from '@mui/material';

const TabContainer = ({
    title,
    description,
    children,
}: {
    title: string;
    description?: string;
    children: React.ReactNode;
}) => {
    const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    return (
        <Stack
            spacing={4}
            sx={[
                !isXs && {
                    pl: 3,
                    pr: 4,
                    py: 6,
                },
            ]}
        >
            <Stack spacing={0.5}>
                <Typography variant='h6' color='primary'>
                    {title}
                </Typography>
                {description && (
                    <Typography variant='body1' color='primary.mui.inactive'>
                        {description}
                    </Typography>
                )}
            </Stack>
            {children}
        </Stack>
    );
};

export default TabContainer;
